import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Empty, NativeSelect, Spinner } from "@/components/Brand";
import { PageTitle } from "@/pages/admin/AdminLayout";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";

const Row = ({ p }) => {
  const [f, setF] = useState({ duration_minutes: p.duration_minutes, status: p.status, max_attempts: p.max_attempts || 0, show_result: p.show_result, show_explanation: p.show_explanation });
  const save = async () => {
    try {
      await api.patch(`/admin/packages/${p.id}`, { ...f, duration_minutes: Number(f.duration_minutes), max_attempts: Number(f.max_attempts) });
      toast.success(`Pengaturan ${p.name} disimpan`);
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <tr className="border-t" data-testid={`exam-settings-row-${p.id}`}>
      <td className="px-4 py-2 font-semibold">{p.name}<div className="text-xs font-normal text-slate-500">{p.category_name} · {p.question_count} soal</div></td>
      <td><Input type="number" min="1" className="w-24" value={f.duration_minutes} onChange={(e) => setF({ ...f, duration_minutes: e.target.value })} data-testid={`es-duration-${p.id}`} /></td>
      <td><NativeSelect className="w-32" value={f.status} onChange={(e) => setF({ ...f, status: e.target.value })} data-testid={`es-status-${p.id}`}><option value="draft">Draf</option><option value="active">Aktif</option><option value="inactive">Nonaktif</option></NativeSelect></td>
      <td><Input type="number" min="0" className="w-20" value={f.max_attempts} onChange={(e) => setF({ ...f, max_attempts: e.target.value })} data-testid={`es-attempts-${p.id}`} /></td>
      <td><Switch checked={f.show_result} onCheckedChange={(v) => setF({ ...f, show_result: v })} data-testid={`es-show-result-${p.id}`} /></td>
      <td><Switch checked={f.show_explanation} onCheckedChange={(v) => setF({ ...f, show_explanation: v })} data-testid={`es-show-expl-${p.id}`} /></td>
      <td className="pr-4 text-right"><button onClick={save} className="rounded bg-[#0A192F] px-3 py-1.5 text-xs font-semibold text-white" data-testid={`es-save-${p.id}`}>Simpan</button></td>
    </tr>
  );
};

export default function ExamSettingsAdmin() {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    api.get("/admin/packages").then((r) => setRows(r.data)).catch((e) => toast.error(errMsg(e)));
  }, []);
  if (!rows) return <Spinner />;
  return (
    <div>
      <PageTitle title="Timer & Pengaturan Ujian" desc="Durasi dihitung dan divalidasi oleh server. Ujian otomatis selesai saat waktu habis; jawaban terkunci setelah selesai." />
      {rows.length === 0 ? <Empty text="Belum ada paket." /> : (
        <div className="overflow-x-auto rounded-xl border bg-white">
          <table className="w-full min-w-[820px] text-sm">
            <thead className="bg-slate-50 text-left text-xs uppercase text-slate-500"><tr><th className="px-4 py-3">Paket</th><th>Durasi (menit)</th><th>Status</th><th>Maks. percobaan</th><th>Hasil tampil</th><th>Pembahasan</th><th /></tr></thead>
            <tbody>{rows.map((p) => <Row key={p.id} p={p} />)}</tbody>
          </table>
        </div>
      )}
      <p className="mt-4 text-xs text-slate-500">Perubahan durasi berlaku untuk sesi ujian baru. Sesi yang sedang berjalan tetap memakai waktu akhir yang ditetapkan saat dimulai.</p>
    </div>
  );
}
